import { lighten } from '@material-ui/core'

import { merge } from 'lodash-es'

import { getBaseLightPerceptThemeOptions, getBaseDarkPerceptThemeOptions, ThemeOptionsProps } from './perceptAppThemeV2'

import { TypographyOptions } from '@material-ui/core/styles/createTypography'

import { AppThemeOptions } from './themeAugmentation'

import { RecursivePartial } from '@percept/types'


const apertoPalette = {
  slate: 'rgb(30,31,29)',
  oatmeal: 'rgb(236,236,227)',
  salmon: 'rgb(243,126,118)',
  lime: 'rgb(203,194,81)',
  darkBlue: 'rgb(0,51,101)',
  red: 'rgb(203,81,111)',
  skyBlue: 'rgb(160,196,212)',
  darkTeal: 'rgb(0,68,81)',
  yellow: 'rgb(255,204,136)',
  darkGreen: 'rgb(25,76,78)',
  mint: 'rgb(141,194,176)',
}


// const fontFamily = 'Questrial, Helvetica Neue, Arial, Helvetica, sans-serif'
const fontFamily = 'Poppins, Helvetica Neue, Arial, Helvetica, sans-serif'

const apertoFontWeights: ThemeOptionsProps['fontWeights'] = {
  bold: 600,
  medium: 500,
  regular: 400,
  light: 400,
  header: 600,
  button: 500,
  input: 500,
  chip: 500,
  caption: 500,
  subtitle: 500,
}

const apertoTypography: TypographyOptions = {
  fontFamily,
}

const commonThemeOptions: RecursivePartial<AppThemeOptions> = {
  shape: {
    borderRadius: 0
  },
  typography: apertoTypography,
}

const lightThemeBorderColor = 'rgba(0,0,0,0.06)'
const lightThemeBorder = `1px solid ${lightThemeBorderColor}`

export const apertoLightThemeOptions = merge(
  getBaseLightPerceptThemeOptions({
    themePalette: {
      primary: apertoPalette.salmon,
      secondary: '#6b6b6b',
      neutral: apertoPalette.darkGreen,
      info: lighten(apertoPalette.darkBlue, 0.4),
      text: '#333',
      success: apertoPalette.mint,
      warning: apertoPalette.yellow,
      error: apertoPalette.red,
      background: lighten(apertoPalette.oatmeal, 0.65),
      paper: '#FFF',
      contrastPanel: apertoPalette.darkGreen,
      infoRangeStart: apertoPalette.skyBlue,
      infoRangeStop: apertoPalette.darkBlue,
    },
    genericChartColours: [
      apertoPalette.salmon,
      apertoPalette.darkTeal,
      apertoPalette.red,
      apertoPalette.lime,
      apertoPalette.yellow,
      apertoPalette.mint,
      apertoPalette.darkGreen,
      apertoPalette.skyBlue,
    ],
    fontWeights: apertoFontWeights,
  }),
  commonThemeOptions,
  {
    palette: {
      primary: {
        contrastText: '#FFF',
      },
      secondary: {
        contrastText: '#FFF',
      },
      info: {
        contrastText: '#FFF',
      },
      success: {
        contrastText: '#FFF',
      },
      error: {
        contrastText: '#FFF',
      },
    },
    appComponents: {
      authenticator: {
        root: {
          boxShadow: '0 0 6px rgba(0,0,0,0.25)',
        }
      }
    },
    // overrides: {
    //   MuiAppBar: {
    //     root: {
    //       borderBottom: lightThemeBorder,
    //     },
    //   },
    //   MuiCard: {
    //     root: {
    //       border: lightThemeBorder,
    //     },
    //   },
    // },
  } as RecursivePartial<AppThemeOptions>
)


export const apertoDarkThemeOptions = merge(
  getBaseDarkPerceptThemeOptions({
    themePalette: {
      primary: apertoPalette.salmon,
      // secondary: apertoPalette.skyBlue,
      secondary: '#6b6b6b',
      // neutral: apertoPalette.darkGreen,
      neutral: 'rgb(71, 102, 104)',
      // info: apertoPalette.darkTeal,
      info: 'rgb(82,180,199)',
      text: '#FFF',
      success: apertoPalette.mint,
      warning: apertoPalette.yellow,
      error: apertoPalette.red,
      background: lighten(apertoPalette.slate, 0.05),
      paper: apertoPalette.slate,
      contrastPanel: apertoPalette.darkGreen,
      infoRangeStart: apertoPalette.skyBlue,
      infoRangeStop: apertoPalette.darkBlue,
    },
    genericChartColours: [
      apertoPalette.salmon,
      apertoPalette.skyBlue,
      apertoPalette.red,
      apertoPalette.yellow,
      apertoPalette.mint,
      apertoPalette.lime,
      apertoPalette.darkGreen,
    ],
    fontWeights: apertoFontWeights,
  }),
  commonThemeOptions,
  {
    palette: {
      primary: {
        contrastText: '#FFF',
      },
      secondary: {
        contrastText: '#FFF',
      },
      info: {
        contrastText: '#FFF',
      },
      success: {
        contrastText: '#FFF',
      },
      error: {
        contrastText: '#FFF',
      },
    },
    appComponents: {
      authenticator: {
        root: {
          boxShadow: '0 0 12px rgba(0,0,0,0.85)',
        }
      },
      table: {
        cellChartColors: {
          line: apertoPalette.salmon,
        },
      },
    },
  } as RecursivePartial<AppThemeOptions>
)
